export interface TurnServer {
  urls: string[];
  username: string;
  credential: string;
}

export interface AppConfig {
  wssUrl: string;
  sipDomain: string;
  stunUrls: string[];
  /** null, solange keine TURN-Zugangsdaten gesetzt sind (sie kommen nur aus der Build-Umgebung). */
  turn: TurnServer | null;
  webrtcPrefix: string;
}

type Env = Partial<Record<keyof ImportMetaEnv, string | undefined>>;

const DEFAULTS = {
  VITE_WSS_URL: 'wss://telefon.geretsried-dlrg.de/ws',
  VITE_SIP_DOMAIN: 'telefonie.geretsried-dlrg.de',
  VITE_STUN_URLS: 'stun:stun.l.google.com:19302',
  VITE_TURN_URLS:
    'turn:telefon.geretsried-dlrg.de:3478?transport=udp,turn:telefon.geretsried-dlrg.de:3478?transport=tcp,turns:telefon.geretsried-dlrg.de:5349?transport=tcp',
  VITE_TURN_USERNAME: '',
  VITE_TURN_CREDENTIAL: '',
  VITE_WEBRTC_PREFIX: '99',
} as const;

const list = (value: string): string[] =>
  value
    .split(',')
    .map((s) => s.trim())
    .filter((s) => s.length > 0);

export function loadConfig(env: Env = import.meta.env): AppConfig {
  const get = (key: keyof typeof DEFAULTS): string => env[key] ?? DEFAULTS[key];
  const turnUrls = list(get('VITE_TURN_URLS'));
  const username = get('VITE_TURN_USERNAME');
  const credential = get('VITE_TURN_CREDENTIAL');
  return {
    wssUrl: get('VITE_WSS_URL'),
    sipDomain: get('VITE_SIP_DOMAIN'),
    stunUrls: list(get('VITE_STUN_URLS')),
    turn: turnUrls.length > 0 && username && credential ? { urls: turnUrls, username, credential } : null,
    webrtcPrefix: get('VITE_WEBRTC_PREFIX'),
  };
}
